export default {
  TOPBAR_SEARCHBAR_MOBILE_ACTIVE(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.topBarStatus.isSearchBarMobileActive = payload;
  },
  TOPBAR_SEARCHBAR(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.topBarStatus.isSearchBarFocus = payload;
  },
  TOPBAR_NOTIFY(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.topBarStatus.isNotifyFocus = payload;
  },
  TOPBAR_USER_PANEL(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.topBarStatus.isUserPanelFocus = payload;
  },
  TOPBAR_USER_FEATURE(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.topBarStatus.isUserFeatureFocus = payload;
  },
  TOPBAR_HAMBURGER(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.topBarStatus.isHamburgerFocus = payload;
  },
  TOPBAR_USER_SCORE(st, payload) {
    // st.scoreStatus = payload;
    // eslint-disable-next-line no-param-reassign
    st.scoreTicker += 1;
    // eslint-disable-next-line no-param-reassign
    st.scoreStatus = payload;
  },
  TOPBAR_USER_UPDATE_POINT(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.userLogin.profile.point = payload;
  },
  UPDATE_PROFILE(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.userLogin.profile = payload;
  },
  LOGIN_MEMBER(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.userLogin = payload;
  },
  USER_AUTH_JWT(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.jwtToken = payload;
  },
  UPDATE_PROFILE_SIDEEFFECT(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.userLogin.profile.sideeffect = payload;
  },
  UPDATE_PROFILE_SIDEEFFECT_PERSONAL(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.userLogin.profile.personal_id = payload;
  },
  USER_SHOP_ADDCART(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.shopCart.push(payload);
  },
  USER_SHOP_REMOVECART(st, payload) {
    // eslint-disable-next-line no-param-reassign
    // payload = { index: 1, item: {}}
    st.shopCart.splice(payload, 1);
  },
  USER_SHOP_REMOVECART_ALL(st, payload) {
    // eslint-disable-next-line no-param-reassign
    // payload = { index: 1, item: {}}
    st.shopCart = [];
  },
  USER_CHECK_SUBSCRIBE(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.subscribe = payload;
  },
  // USER_UPDATE_CHAT_REMIND(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.userLogin.profile.chat_remind = payload;
  // },
  CONSULT_WEBSOCKET(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.consultWebSocket = payload;
  },
  EXCLUSIVE_WEBSOCKET(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.exclusiveWebSocket = payload;
  },
  USER_SHOP_STEP(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.shopCartFlow = payload;
  },
  USER_SHOP_PURCHASE_TYPE(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.shopPurchaseType = payload;
  },
  USER_UPDATE_ANALYSIS_COUNT(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.userLogin.profile.analysis_count = payload;
  },
  LIFF_VENDOR(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.liffVendor = payload;
  },
};
